"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeHTMLTag = void 0;
var lodash_1 = __importDefault(require("lodash"));
var removeHTMLTag = function (msg) {
    var htmlSections = /<(p|ul)\b[\s\S]+?<\/(p|ul)>/g; // (p|ul) matches <p> or <ul>
    var sections = msg.match(htmlSections) || [msg];
    var anyHtmlTag = /<[^>]*>/g;
    /** _.unescape converts following HTML entities: &amp;, &lt;, &gt;, &quot;, and &#39; to text.
     * To unescape other HTML entities, use a third-party library like 'he'.
     */
    var textFromHTML = lodash_1.default.unescape(sections.join(' [...] ').replace(anyHtmlTag, ''));
    return textFromHTML;
};
exports.removeHTMLTag = removeHTMLTag;
